import { render, staticRenderFns } from "./CookiePolicy.html?vue&type=template&id=6d760758&scoped=true&"
import script from "./CookiePolicy.ts?vue&type=script&lang=ts&"
export * from "./CookiePolicy.ts?vue&type=script&lang=ts&"
import style0 from "@/scss/components/body/_body.scss?vue&type=style&index=0&id=6d760758&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d760758",
  null
  
)

export default component.exports